export default __webpack_public_path__ + "static/media/addPhoto.515d2fa9.svg";